import React, {Component} from 'react';
/*import {FormattedDate} from 'react-intl';*/
import CSSModules from 'react-css-modules';
import classnames from 'classnames';
import styles from './styles.scss';

class TimeCell extends Component {
    constructor(props) {
        super(props);
        this.name = 'TimeCell';
      }
    //const {time} = props;
  //cellContent = date.toDateString();
  //{date.toDateString()}<br/>{date.toTimeString()}
    render() {
        return (<div><span>{this.props.timestamp.date}</span><br/><span>{this.props.timestamp.time}</span></div>);
    }

}

export default CSSModules(TimeCell, styles);



// WEBPACK FOOTER //
// ./components/qual/Table/TableCells/Time/TimeCell_component.js